import { Button, Modal, Row } from "antd";
import React from "react";

export default function ConfirmDeleteModal({ setModalState, modalState, handleDelete }) {
  return (
    <Modal onCancel={() => setModalState({ ...modalState, isVisible: false })} open={modalState.isVisible} footer={null} title="Delete Treatment">
      <p>Are you sure you want to delete this treatment?</p>
      <Row justify={"end"}>
        <Button type="primary" onClick={() => setModalState({ ...modalState, isVisible: false })} style={{ marginRight: "10px" }}>
          No
        </Button>
        <Button
          onClick={() => {
            handleDelete(modalState.deleteId);
            setModalState({ isVisible: false, deleteId: null });
          }}
        >
          Yes
        </Button>
      </Row>
    </Modal>
  );
}
